(() => {
  'use strict';

  /*
   * Balbum x Voicestories Launch-Aktion
   *
   * Aktionszeitraum:
   * 20.09.2026 10:00 MESZ
   * bis
   * 26.09.2026 10:00 MESZ
   *
   * Pro Warenkorb maximal 1 automatisches Geschenk.
   */

  const CONFIG = {
    giftVariantId: 54819046949210,
    giftProductId: 11001534546266,

    maxGiftQuantity: 1,

    // ZUM TESTEN zunächst true.
    // Vor dem Livegang unbedingt auf false setzen.
    forceActive: false,

    start: new Date('2026-09-20T10:00:00+02:00'),
    end: new Date('2026-09-26T10:00:00+02:00'),

    /*
     * Nach externen Warenkorbänderungen warten wir,
     * bis der Bundler / das Theme zur Ruhe gekommen ist.
     */
    cartQuietTimeMs: 1500,

    /*
     * Ein vorhandenes Geschenk wird erst entfernt,
     * wenn der Warenkorb zweimal nacheinander stabil
     * als nicht qualifiziert erkannt wurde.
     */
    removalConfirmDelayMs: 1200,

    qualifyingPresetProductIds: [
      10720952975706, // Kindheitsjahre - Wald | Altrosa
      10720950681946, // Kindheitsjahre - Wald | Dunkelgruen
      10720947306842, // Kindheitsjahre - Meer | Hellblau
      10720941277530, // Kindheitsjahre - Natur | Salbeigruen
      10720931643738  // Kindheitsjahre - Natur | Beige
    ],

    configuredChildhoodStickerProductId: 10720796016986
};

  const GIFT_PROPERTY_KEY = '_balbum_launch_gift';
  const GIFT_PROPERTY_VALUE = 'voicestories-mini';

  let syncTimer = null;
  let syncRunning = false;
  let syncQueued = false;

  /*
   * Während eigener Cart-Requests ignorieren wir
   * die globale Fetch-Überwachung.
   */
  let internalCartRequest = false;

  /*
   * Jede externe Cart-Änderung erhöht die Revision.
   * Damit erkennen wir, ob der Warenkorb während
   * einer Prüfung erneut verändert wurde.
   */
  let cartRevision = 0;

  function rootUrl() {
    return window.Shopify?.routes?.root || '/';
  }

  function campaignIsActive() {
    if (CONFIG.forceActive) {
      return true;
    }

    const now = new Date();

    return (
      now >= CONFIG.start &&
      now < CONFIG.end
    );
  }

  function sleep(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  async function getCart() {
    const response = await window.fetch(
      `${rootUrl()}cart.js`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        `Cart konnte nicht geladen werden (${response.status})`
      );
    }

    return response.json();
  }

  function hasQualifyingPresetBundle(cart) {
    return cart.items.some((item) => {
      const productId = Number(item.product_id);

      return CONFIG.qualifyingPresetProductIds.includes(
        productId
      );
    });
  }

  function getConfiguredBundles(cart) {
    const bundles = new Map();

    cart.items.forEach((item) => {
      const properties = item.properties || {};

      const bundlerId =
        properties._bundler_id;

      const sectionId =
        properties._bundle_section_id;

      if (
        bundlerId === undefined ||
        bundlerId === null ||
        bundlerId === '' ||
        sectionId === undefined ||
        sectionId === null ||
        sectionId === ''
      ) {
        return;
      }

      const bundleKey = String(bundlerId);
      const sectionKey = String(sectionId);
      const productId = Number(item.product_id);

      if (!bundles.has(bundleKey)) {
        bundles.set(bundleKey, {
          sections: new Set(),
          productIds: new Set()
        });
      }

      const bundle = bundles.get(bundleKey);

      bundle.sections.add(sectionKey);
      bundle.productIds.add(productId);
    });

    return bundles;
  }

  function hasCompleteConfiguredAlbum(cart) {
    const bundles = getConfiguredBundles(cart);

    const requiredSections = [
      '0',
      '1',
      '2',
      '3',
      '4'
    ];

    for (const bundle of bundles.values()) {
      const complete = requiredSections.every(
        (sectionId) => bundle.sections.has(sectionId)
      );

      const isChildhoodAlbum =
        bundle.productIds.has(
          CONFIG.configuredChildhoodStickerProductId
        );

      if (complete && isChildhoodAlbum) {
        return true;
      }
    }

    return false;
  }
  function configuredBundleDebug(cart) {
    const bundles = getConfiguredBundles(cart);

    return Array.from(
      bundles.entries()
    ).map(([bundlerId, bundle]) => ({
      bundlerId,
      sections: Array.from(bundle.sections)
        .sort()
        .join(', '),
      productIds: Array.from(bundle.productIds)
        .sort((a, b) => a - b)
        .join(', '),
      isChildhoodAlbum:
        bundle.productIds.has(
          CONFIG.configuredChildhoodStickerProductId
        )
    }));
  }
  function cartQualifies(cart) {
    return (
      hasQualifyingPresetBundle(cart) ||
      hasCompleteConfiguredAlbum(cart)
    );
  }

  function isAutomaticGift(item) {
    const properties = item.properties || {};

    return (
      Number(item.variant_id) ===
        CONFIG.giftVariantId &&
      properties[GIFT_PROPERTY_KEY] ===
        GIFT_PROPERTY_VALUE
    );
  }

  function findAutomaticGift(cart) {
    return cart.items.find(isAutomaticGift);
  }

  async function internalFetch(url, options) {
    internalCartRequest = true;

    try {
      return await window.fetch(url, options);
    } finally {
      internalCartRequest = false;
    }
  }

  async function addGift() {
    const response = await internalFetch(
      `${rootUrl()}cart/add.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: CONFIG.giftVariantId,
              quantity: 1,
              properties: {
                [GIFT_PROPERTY_KEY]:
                  GIFT_PROPERTY_VALUE
              }
            }
          ]
        })
      }
    );

    if (!response.ok) {
      const message = await response
        .text()
        .catch(() => '');

      console.warn(
        '[Balbum Voicestories] Geschenk konnte nicht hinzugefügt werden.',
        response.status,
        message
      );

      return false;
    }

    return true;
  }

  async function setGiftQuantity(
    lineKey,
    quantity
  ) {
    const response = await internalFetch(
      `${rootUrl()}cart/change.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity
        })
      }
    );

    if (!response.ok) {
      const message = await response
        .text()
        .catch(() => '');

      console.warn(
        '[Balbum Voicestories] Geschenkmenge konnte nicht geändert werden.',
        response.status,
        message
      );

      return false;
    }

    return true;
  }

  function notifyCartChanged() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );
  }

  /*
   * Vor dem Entfernen prüfen wir ein zweites Mal.
   *
   * Wenn zwischen den Prüfungen ein weiterer externer
   * Cart-Request stattgefunden hat, brechen wir ab.
   */
  async function confirmGiftRemoval(
    originalRevision
  ) {
    await sleep(CONFIG.removalConfirmDelayMs);

    if (cartRevision !== originalRevision) {
      return null;
    }

    const cart = await getCart();

    if (
      campaignIsActive() &&
      cartQualifies(cart)
    ) {
      return null;
    }

    return cart;
  }

  async function syncGift() {
    if (syncRunning) {
      syncQueued = true;
      return;
    }

    syncRunning = true;

    const revisionAtStart = cartRevision;

    try {
      const cart = await getCart();

      const active =
        campaignIsActive();

      const qualifies =
        active && cartQualifies(cart);

      const gift =
        findAutomaticGift(cart);

      /*
       * Qualifizierender Warenkorb:
       * Geschenk hinzufügen oder Menge auf 1 setzen.
       */
      if (qualifies) {
        if (!gift) {
          /*
           * Wenn seit Start dieser Prüfung bereits wieder
           * ein externer Cart-Request stattgefunden hat,
           * greifen wir nicht in den Warenkorb ein.
           */
          if (cartRevision !== revisionAtStart) {
            return;
          }

          const added = await addGift();

          if (added) {
            console.info(
              '[Balbum Voicestories] Geschenk hinzugefügt.'
            );

            notifyCartChanged();
          }

          return;
        }

        if (
          Number(gift.quantity) !==
          CONFIG.maxGiftQuantity
        ) {
          if (cartRevision !== revisionAtStart) {
            return;
          }

          const changed =
            await setGiftQuantity(
              gift.key,
              CONFIG.maxGiftQuantity
            );

          if (changed) {
            notifyCartChanged();
          }
        }

        return;
      }

      /*
       * Kein Geschenk vorhanden:
       * Es gibt nichts zu tun.
       */
      if (!gift) {
        return;
      }

      /*
       * Vor dem Entfernen zweite stabile Prüfung.
       * Dadurch führt ein kurzfristig unvollständiger
       * Bundler-Zustand nicht zum Entfernen.
       */
      const confirmedCart =
        await confirmGiftRemoval(
          revisionAtStart
        );

      if (!confirmedCart) {
        return;
      }

      const confirmedGift =
        findAutomaticGift(confirmedCart);

      if (!confirmedGift) {
        return;
      }

      /*
       * Unmittelbar vor dem Entfernen nochmals sicherstellen,
       * dass seit der Bestätigung nichts geändert wurde.
       */
      if (cartRevision !== revisionAtStart) {
        return;
      }

      const removed =
        await setGiftQuantity(
          confirmedGift.key,
          0
        );

      if (removed) {
        console.info(
          '[Balbum Voicestories] Geschenk entfernt.'
        );

        notifyCartChanged();
      }
    } catch (error) {
      console.warn(
        '[Balbum Voicestories] Synchronisierung fehlgeschlagen:',
        error
      );
    } finally {
      syncRunning = false;

      if (syncQueued) {
        syncQueued = false;
        scheduleSync();
      }
    }
  }

  /*
   * Echtes Debouncing:
   *
   * Jeder neue externe Cart-Request setzt den Timer
   * wieder zurück. Erst wenn der Warenkorb für
   * cartQuietTimeMs ruhig war, prüfen wir ihn.
   */
  function scheduleSync(
    delay = CONFIG.cartQuietTimeMs
  ) {
    clearTimeout(syncTimer);

    syncTimer = setTimeout(() => {
      syncGift();
    }, delay);
  }

  /*
   * Initiale Prüfung beim Laden der Seite.
   */
  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => scheduleSync(500)
    );
  } else {
    scheduleSync(500);
  }

  /*
   * Cart-Events des Themes.
   */
  document.documentElement.addEventListener(
    'cart:change',
    () => {
      /*
       * Unsere eigenen Events brauchen keine sofortige
       * erneute Synchronisation.
       */
      if (!internalCartRequest) {
        scheduleSync();
      }
    }
  );

  document.addEventListener(
    'cart:updated',
    () => {
      if (!internalCartRequest) {
        scheduleSync();
      }
    }
  );

  /*
   * Externe Änderungen über Shopify Ajax Cart API erkennen.
   *
   * Wichtig:
   * Eigene Gift-Requests werden nicht als neue externe
   * Cart-Aktivität gewertet.
   */
  const originalFetch =
    window.fetch.bind(window);

  window.fetch = async (...args) => {
    const wasInternal =
      internalCartRequest;

    const response =
      await originalFetch(...args);

    try {
      const request = args[0];

      const url =
        typeof request === 'string'
          ? request
          : request?.url || '';

      const isCartMutation =
        /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(
          url
        );

      if (
        isCartMutation &&
        !wasInternal
      ) {
        cartRevision += 1;
        scheduleSync();
      }
    } catch (error) {
      /*
       * Die eigentliche Fetch-Anfrage darf durch
       * unsere Überwachung niemals scheitern.
       */
    }

    return response;
  };

  /*
   * Debug-Schnittstelle.
   */
  window.BalbumVoicestoriesGift = {
    sync: syncGift,

    async status() {
      const cart = await getCart();

      const configuredAlbum =
        hasCompleteConfiguredAlbum(cart);

      const presetBundle =
        hasQualifyingPresetBundle(cart);

      const gift =
        findAutomaticGift(cart);

      const status = {
        campaignActive:
          campaignIsActive(),

        forceActive:
          CONFIG.forceActive,

        configuredAlbum,

        presetBundle,

        qualifies:
          configuredAlbum ||
          presetBundle,

        giftPresent:
          Boolean(gift),

        giftQuantity:
          gift?.quantity || 0,

        giftVariantId:
          CONFIG.giftVariantId,

        cartRevision
      };

      console.table(status);

      const bundles =
        configuredBundleDebug(cart);

      if (bundles.length > 0) {
        console.info(
          '[Balbum Voicestories] Erkannte Konfigurator-Bundles:'
        );

        console.table(bundles);
      } else {
        console.info(
          '[Balbum Voicestories] Keine Konfigurator-Bundle-Properties gefunden.'
        );
      }

      return {
        ...status,
        bundles
      };
    }
  };

  console.info(
    '[Balbum Voicestories] Gift logic v2 loaded.'
  );
})();